import { ApiProperty } from "@nestjs/swagger";

export class ColumnsRequest{
    @ApiProperty()
    columnsId:number;
}